import * as SwitchPrimitives from '@radix-ui/react-switch';

/**
 * IOSSwitch — die einzige Switch-Komponente der App.
 * Native iOS-Proportionen (51×31, Knob 27 mit 2pt Inset), grün im Checked-State,
 * Knob-Bewegung + Hintergrund animiert. Ein Design, eine Farbe: var(--accent-green).
 * Keine Farb-Props.
 */
export function IOSSwitch({ checked, onCheckedChange, disabled, 'data-testid': dataTestid }) {
  return (
    <SwitchPrimitives.Root
      data-testid={dataTestid}
      checked={checked}
      onCheckedChange={onCheckedChange}
      disabled={disabled}
      className="relative inline-flex h-[31px] w-[51px] shrink-0 cursor-pointer items-center rounded-full bg-[var(--fill-tertiary)] transition-colors duration-200 ease-out focus-visible:outline-none disabled:cursor-not-allowed disabled:opacity-50 data-[state=checked]:bg-[var(--accent-green)]"
    >
      <SwitchPrimitives.Thumb className="pointer-events-none block h-[27px] w-[27px] translate-x-[2px] rounded-full bg-white shadow-[0_2px_6px_rgba(0,0,0,0.3)] transition-transform duration-200 ease-out data-[state=checked]:translate-x-[22px]" />
    </SwitchPrimitives.Root>
  );
}
